'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = jQuery;

/**
 * WeatherControls - Interactive controls for weather layer visibility and animation
 */

var WeatherControls = function () {
    function WeatherControls($container, mapService) {
        var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var map = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        _classCallCheck(this, WeatherControls);

        this.$container = $container;
        this.mapService = mapService;
        this.map = map; // Store reference to Map instance
        this.settings = $.extend({
            enabled: false,
            layers: [],
            interfaceEnabled: false,
            showToggles: true,
            showPlayback: true,
            opacity: 0.6
        }, settings);

        this.currentTimeIndex = 0;
        this.timestamps = this.generateTimestamps();
        this.selectedLayer = null; // Track single selected layer
        this.updateTimeout = null; // For debouncing updates
        this.isUpdating = false; // Track if update is in progress

        // Layer display names
        this.layerNames = {
            'clouds_new': 'Clouds',
            'precipitation_new': 'Precipitation',
            'temp_new': 'Temperature',
            'wind_new': 'Wind Speed',
            'pressure_new': 'Pressure'
        };

        if (this.settings.enabled && this.settings.interfaceEnabled) {
            this.init();
        }
    }

    _createClass(WeatherControls, [{
        key: 'init',
        value: function init() {
            this.createControlsHTML();
            this.attachEventListeners();
            this.positionControls();

            // Start collapsed on mobile
            if (this.isMobile()) {
                this.$controls.addClass('mpfy-collapsed');
                this.$toggleArrow.html('◀');
                this.$content.hide();
            }

            // Auto-select the first layer by default
            if (this.settings.layers.length > 0) {
                var firstLayer = this.settings.layers[0];
                this.selectedLayer = firstLayer;

                // Add active class to first toggle
                this.$controls.find('.mpfy-weather-layer-toggle[data-layer="' + firstLayer + '"]').addClass('active');

                // Show the first layer on the map
                this.mapService.showWeatherLayer(firstLayer);

                // Update to current timestamp
                this.updateTimeline();
                this.updateWeatherLayers();
            }
        }
    }, {
        key: 'createControlsHTML',
        value: function createControlsHTML() {
            var _this = this;

            var html = '<div class="mpfy-weather-controls">';

            // Determine if we have toggles section
            var hasToggles = this.settings.showToggles && this.settings.layers.length > 0;

            // Toggle arrow - position depends on whether toggles exist
            if (hasToggles) {
                // Default position: outside content wrapper
                html += '<span class="mpfy-weather-toggle-arrow">▶</span>';
            }

            // Collapsible content wrapper
            html += '<div class="mpfy-weather-content">';

            // Layer Toggles Section
            if (hasToggles) {
                html += '<div class="mpfy-weather-toggles">';
                html += '<div class="mpfy-weather-toggles-title">Weather Layers</div>';

                this.settings.layers.forEach(function (layerType) {
                    var layerName = _this.layerNames[layerType] || layerType;

                    // Add info icon for Temperature layer
                    var infoIcon = layerType === 'temp_new' ? '<span class="mpfy-weather-info-icon" data-tooltip="Click anywhere on the map to see any region\'s temperature">ⓘ</span>' : '';

                    html += '\n                    <div class="mpfy-weather-layer-toggle" data-layer="' + layerType + '">\n                        ' + layerName + infoIcon + '\n                    </div>\n                ';
                });

                html += '</div>';
            }

            // Timeline Controls Section
            if (this.settings.showPlayback && this.settings.layers.length > 0) {
                html += '<div class="mpfy-weather-playback">';
                html += '\n                <div class="mpfy-weather-playback-header">\n                    <div class="mpfy-weather-playback-title">Adjust Time</div>\n                    <button class="mpfy-weather-reset-btn" title="Reset to current time">\u21BB</button>';

                // If no toggles, arrow goes in header next to refresh button
                if (!hasToggles) {
                    html += '<span class="mpfy-weather-toggle-arrow">▶</span>';
                }

                html += '\n                </div>\n            ';
                html += '\n                <div class="mpfy-weather-timeline">\n                    <div class="mpfy-weather-timeline-slider">\n                        <div class="mpfy-weather-timeline-progress"></div>\n                    </div>\n                    <div class="mpfy-weather-timeline-label">Current Weather</div>\n                </div>\n            ';
                html += '</div>';
            }

            html += '</div>'; // Close mpfy-weather-content
            html += '</div>'; // Close mpfy-weather-controls

            this.$container.append(html);
            this.$controls = this.$container.find('.mpfy-weather-controls');
            this.$content = this.$controls.find('.mpfy-weather-content');
            this.$toggleArrow = this.$controls.find('.mpfy-weather-toggle-arrow');
            this.$playbackSection = this.$controls.find('.mpfy-weather-playback');
            this.$progress = this.$controls.find('.mpfy-weather-timeline-progress');
            this.$timelineLabel = this.$controls.find('.mpfy-weather-timeline-label');
            this.$slider = this.$controls.find('.mpfy-weather-timeline-slider');
        }
    }, {
        key: 'attachEventListeners',
        value: function attachEventListeners() {
            var _this2 = this;

            // Collapse/Expand toggle
            this.$toggleArrow.on('click', function (e) {
                e.stopPropagation();
                _this2.toggleCollapse();
            });

            // Layer toggle clicks - single selection
            this.$controls.find('.mpfy-weather-layer-toggle').on('click', function (e) {
                var $toggle = $(e.currentTarget);
                var layerType = $toggle.data('layer');

                // If clicking the currently selected layer, deselect it
                if (_this2.selectedLayer === layerType) {
                    _this2.mapService.hideWeatherLayer(layerType);

                    // Remove temperature marker if deselecting temperature layer
                    if (layerType === 'temp_new' && _this2.map && _this2.map.removeTemperatureMarker) {
                        _this2.map.removeTemperatureMarker();
                    }

                    _this2.selectedLayer = null;
                    $toggle.removeClass('active');
                } else {
                    // Remove temperature marker if switching away from temperature layer
                    if (_this2.selectedLayer === 'temp_new' && _this2.map && _this2.map.removeTemperatureMarker) {
                        _this2.map.removeTemperatureMarker();
                    }

                    // Hide previously selected layer
                    if (_this2.selectedLayer) {
                        _this2.mapService.hideWeatherLayer(_this2.selectedLayer);
                        _this2.$controls.find('.mpfy-weather-layer-toggle[data-layer="' + _this2.selectedLayer + '"]').removeClass('active');
                    }

                    // Show new layer
                    _this2.selectedLayer = layerType;
                    _this2.mapService.showWeatherLayer(layerType);
                    $toggle.addClass('active');

                    // Update the layer to current timestamp
                    _this2.updateWeatherLayers();
                }
            });

            // Reset button - return to current time
            this.$controls.find('.mpfy-weather-reset-btn').on('click', function () {
                _this2.resetToCurrentTime();
            });

            // Timeline slider - support both click and drag
            var isDragging = false;

            this.$slider.on('mousedown', function (e) {
                isDragging = true;
                _this2.updateTimeFromSlider(e);
            });

            $(document).on('mousemove', function (e) {
                if (isDragging) {
                    _this2.updateTimeFromSlider(e);
                }
            });

            $(document).on('mouseup', function () {
                isDragging = false;
            });

            // Also handle touch events for mobile
            this.$slider.on('touchstart', function (e) {
                isDragging = true;
                _this2.updateTimeFromSlider(e.touches[0]);
            });

            $(document).on('touchmove', function (e) {
                if (isDragging) {
                    _this2.updateTimeFromSlider(e.touches[0]);
                }
            });

            $(document).on('touchend', function () {
                isDragging = false;
            });

            // Reposition on window resize to handle responsive behavior
            $(window).on('resize', function () {
                _this2.positionControls();
            });
        }
    }, {
        key: 'resetToCurrentTime',
        value: function resetToCurrentTime() {
            // Reset to current time (index 0)
            this.currentTimeIndex = 0;
            this.updateTimeline();
            this.updateWeatherLayers();
        }
    }, {
        key: 'updateTimeFromSlider',
        value: function updateTimeFromSlider(e) {
            var $slider = this.$slider;
            var clickX = e.pageX - $slider.offset().left;
            var width = $slider.width();
            var percentage = Math.max(0, Math.min(1, clickX / width));

            this.currentTimeIndex = Math.floor(percentage * (this.timestamps.length - 1));
            this.updateTimeline();
            this.updateWeatherLayers();
        }
    }, {
        key: 'positionControls',
        value: function positionControls() {
            // Check if search/filter controls exist and add class to push them left
            var $controlsWrap = this.$container.find('.mpfy-controls-wrap');

            if ($controlsWrap.length > 0 && $controlsWrap.is(':visible')) {
                this.$container.addClass('has-weather-controls');

                // On mobile, position weather controls below the search/filter controls
                if (this.isMobile()) {
                    var controlsHeight = $controlsWrap.outerHeight(true);
                    this.$controls.css('top', controlsHeight + 10 + 'px');
                } else {
                    // Reset to CSS default on desktop
                    this.$controls.css('top', '');
                }
            }
        }
    }, {
        key: 'generateTimestamps',
        value: function generateTimestamps() {
            // Generate timestamps in hourly increments
            // Cover current time to 48 hours in future (49 timestamps total)
            var timestamps = [];
            var now = new Date();

            // Round to nearest hour
            now.setMinutes(0, 0, 0);

            var currentTime = now.getTime();

            // Generate 49 timestamps (current hour + 48 hours forward)
            for (var i = 0; i <= 48; i++) {
                timestamps.push(currentTime + i * 60 * 60 * 1000); // Every hour
            }

            // Start at current time (index 0)
            this.currentTimeIndex = 0;

            return timestamps;
        }
    }, {
        key: 'updateTimeline',
        value: function updateTimeline() {
            var progress = this.currentTimeIndex / (this.timestamps.length - 1) * 100;
            this.$progress.css('width', progress + '%');

            // Update label with formatted date/time
            var timestamp = this.timestamps[this.currentTimeIndex];
            var date = new Date(timestamp);

            // Format: "Oct 12, 2:00 PM" or "Oct 12, 2:10 PM"
            var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var month = monthNames[date.getMonth()];
            var day = date.getDate();
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // Convert 0 to 12
            var minutesStr = minutes < 10 ? '0' + minutes : minutes;

            var label = month + ' ' + day + ', ' + hours + ':' + minutesStr + ' ' + ampm;
            this.$timelineLabel.text(label);
        }
    }, {
        key: 'updateWeatherLayers',
        value: function updateWeatherLayers() {
            var _this3 = this;

            // Debounce rapid updates when dragging slider
            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
            }

            // Update only the selected layer with new timestamp
            this.updateTimeout = setTimeout(function () {
                if (_this3.selectedLayer && !_this3.isUpdating) {
                    _this3.isUpdating = true;
                    var timestamp = Math.floor(_this3.timestamps[_this3.currentTimeIndex] / 1000);
                    _this3.mapService.updateWeatherLayerTime(_this3.selectedLayer, timestamp);

                    // Allow next update after a short delay
                    setTimeout(function () {
                        _this3.isUpdating = false;
                    }, 100);
                }
            }, 150); // 150ms debounce delay
        }
    }, {
        key: 'isMobile',
        value: function isMobile() {
            return $(window).width() <= 768;
        }
    }, {
        key: 'show',
        value: function show() {
            this.$controls.removeClass('mpfy-hidden');
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.$controls.addClass('mpfy-hidden');
        }
    }, {
        key: 'toggleCollapse',
        value: function toggleCollapse() {
            this.$controls.toggleClass('mpfy-collapsed');

            if (this.$controls.hasClass('mpfy-collapsed')) {
                // Collapsed state - hide content with fade, show left arrow
                this.$content.fadeOut(300);
                this.$toggleArrow.html('◀');

                // If arrow is inside content (no toggles case), move it outside temporarily
                var hasToggles = this.$controls.find('.mpfy-weather-toggles').length > 0;
                if (!hasToggles) {
                    this.$toggleArrow.appendTo(this.$controls);
                }
            } else {
                // Expanded state - show content with fade, show right arrow
                this.$content.fadeIn(300);
                this.$toggleArrow.html('▶');

                // If arrow was moved outside, put it back in the header
                var _hasToggles = this.$controls.find('.mpfy-weather-toggles').length > 0;
                if (!_hasToggles) {
                    this.$toggleArrow.appendTo(this.$controls.find('.mpfy-weather-playback-header'));
                }
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (this.$controls) {
                this.$controls.remove();
            }
            // Clean up event listeners
            $(document).off('mousemove');
            $(document).off('mouseup');
            $(document).off('touchmove');
            $(document).off('touchend');
        }
    }]);

    return WeatherControls;
}();

module.exports = WeatherControls;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/weather-controls.js
// module id = 22
// module chunks = 0